import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './common/context/AuthContext';

// Common Landing & Public Pages
import TOBOLanding from './common/landing/TOBOLanding';
import Navbar from './common/components/Navbar/Navbar';
import Footer from './common/components/Footer/Footer';
import Home from './common/landing/Home/Home';
import About from './common/landing/About/About';
import Gallery from './common/landing/Gallery/Gallery';
import ContactUs from './common/landing/Contact/ContactUs';
import OurMenus from './common/landing/Menus/OurMenus';
import MenuItem from './common/landing/MenuItem/MenuItem';
import Support from './components/Support/Support';
import ViewSupport from './components/Support/ViewSupport';

// Modular Sub-Routers
import RestaurantRoutes from './restaurant/routes/RestaurantRoutes';
import SalonRoutes from './salon/routes/SalonRoutes';

// Shared UI Shell Elements
import Sidebar from './restaurant/components/Sidebar';
import ToboHeader from './restaurant/components/ToboHeader';

function getBusinessType() {
  return localStorage.getItem('businessType') || 'restaurant';
}

const App = () => (
  <AuthProvider>
    <Router>
      <Main />
    </Router>
  </AuthProvider>
);

const Main = () => {
  const location = useLocation();
  const { isLoading, isAuthenticated } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const businessType = getBusinessType();
  const isSalon = isAuthenticated && businessType === 'salon';

  const navbarFooterRoutes = ["/", "/home", "/about-us", "/gallery", "/contact", "/our-menus", "/menu-item"];
  const shouldShowNavbarFooter = navbarFooterRoutes.some(r =>
    location.pathname === r ||
    (r === "/menu-item" && location.pathname.startsWith("/menu-item/")) ||
    location.pathname.startsWith("/menu/")
  );

  const publicRoutes = [
    "/", "/home", "/tobo-landing", "/signup", "/pinlogin", "/login-method-selection",
    "/signin", "/restaurant/signin", "/salon/signin", "/outlet-selection",
    "/forgot-password", "/restaurant/forgot-password", "/salon/forgot-password",
    "/info", "/deleteappaccount", "/account-delete",
  ];

  const hideHeaderRoutes =
    location.pathname.startsWith("/print-bill/") ||
    location.pathname.startsWith("/print-kot/");

  const isPublicRoute = publicRoutes.some(r =>
    location.pathname.toLowerCase() === r.toLowerCase()
  ) || shouldShowNavbarFooter;

  const isPublicSupport = location.pathname.toLowerCase() === "/support" && !isAuthenticated;
  const isSalonRoute = location.pathname.startsWith('/salon/');

  const shouldShowSidebar =
    !isLoading && isAuthenticated && !isPublicRoute && !isPublicSupport &&
    !isSalonRoute && !isSalon;

  const shouldShowHeader = shouldShowSidebar && !hideHeaderRoutes;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {shouldShowNavbarFooter && <Navbar />}

      <div className="flex flex-1">
        {shouldShowSidebar && (
          <Sidebar
            isMobileOpen={isMobileMenuOpen}
            setIsMobileOpen={setIsMobileMenuOpen}
          />
        )}

        <div className={`flex-1 min-h-screen flex flex-col ${!shouldShowSidebar ? 'w-full' : ''}`}>
          {shouldShowHeader && (
            <ToboHeader onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
          )}

          <main className="flex-1 overflow-auto">
            <Routes>
              {/* Public & Landing Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/tobo-landing" element={<TOBOLanding />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/gallery" element={<Gallery accessToken="IGQWROaEdMTW1CbHQybVBwYlk1eE5TWHRRQngwZAWNDa2ZAUWTFuWTMzb213NWR0WFZANcEJwWnI2d1ZArYjliazRyQlgxd3ZAES3hWZAlZAvbWxlRkswVk5ldzdhZAHFrcUs4MzVRazF3NW5GZAUtMVVhGbkFuOHlxRHlvaE0ZD" limit={21} />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/our-menus" element={<OurMenus />} />
              <Route path="/menu/*" element={<OurMenus />} />
              <Route path="/menu-item/:id" element={<MenuItem />} />
              <Route path="/support" element={<Support />} />

              {/* Salon Module Routes */}
              <Route path="/salon/*" element={<SalonRoutes />} />

              {/* Restaurant Module Routes */}
              <Route path="/*" element={<RestaurantRoutes />} />
            </Routes>
          </main>
        </div>
      </div>

      {shouldShowNavbarFooter && <Footer />}
    </div>
  );
};

export default App;